import { render, staticRenderFns } from "./Snooze.vue?vue&type=template&id=360cf893&scoped=true"
import script from "./Snooze.vue?vue&type=script&lang=js"
export * from "./Snooze.vue?vue&type=script&lang=js"
import style0 from "./Snooze.vue?vue&type=style&index=0&id=360cf893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360cf893",
  null
  
)

export default component.exports